import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-slate-200" }
const _hoisted_2 = { class: "mx-auto w-3/4 text-left text-base" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-5" }, null, -1)
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "h-1" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "h-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-1" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "h-1" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "h-1" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "h-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Languages = _resolveComponent("Languages")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Languages, { classValue: "rounded p-1" })
      ]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("footer.home")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_5,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("header.pictureBook")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_6,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("header.shop")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_7,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/termsofservice')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("footer.termofservice")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_8,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/privacy')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("footer.privacy")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_9,
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/notation')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("footer.notation")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_10
    ])
  ]))
}